import React from "react";
import FadeInSection from "./FadeInSection"; // Import animation wrapper
import "./KD.css"; // Import the CSS file
import KDModleeModelSelection from "./KDModleeModelSelection"
import KDOptimizationComparison from "./KDOptimizationComparison"

const AIImprovement = () => {
  return (
    <FadeInSection className="ai-improvement-container">

        <img
          src={`${process.env.PUBLIC_URL}/knowledge_distillation.svg`} 
          alt="Knowledge Distillation" 
          className="agent-image"
        />


      <h2 className="ai-improvement-title">Knowledge Distillation</h2>

      <p className="ai-improvement-description">

        Modlee enables automated AI Agent task optimization through knowledge distillation, a process that transfers knowledge from a larger model to a smaller one. This reduces operational costs and speeds up development without sacrificing performance.

      </p>

      <div className="ai-improvement-grid">
        {/* Benefit 1 */}
        <div className="ai-improvement-item">
          <h3 className="ai-improvement-subtitle">Task Reformatting</h3>
          <p className="ai-improvement-text">
            Any AI agent task can be restructured as a deep learning task for optimization - text classification, regression, or sequence-to-sequence.
          </p>
        </div>

        {/* Benefit 2 */}
        <div className="ai-improvement-item">
          <h3 className="ai-improvement-subtitle">Self-Optimizing AI</h3>
          <p className="ai-improvement-text">
            Our system automatically selects a model for distillation, and trains it on the inputs and outputs of the LLM-supported task, ensuring optimal performance and efficiency.
          </p>
        </div>

        {/* Benefit 3 */}
        <div className="ai-improvement-item">
          <h3 className="ai-improvement-subtitle">Model Selection</h3>
          <p className="ai-improvement-text">
            Modlee's system recommends models by learning from past experiments on similar datasets, leveraging community knowledge and organizational knowledge privately.
          </p>
        </div>
      </div>

      <KDModleeModelSelection/>

      {/* <KDOptimizationComparison/> */}

    </FadeInSection>
  );
};

export default AIImprovement;
